import {
  deleteAdminV1StoresStoreIdPaymentMethodsId,
  getAdminV1StoresStoreIdPaymentMethods,
  patchAdminV1StoresStoreIdPaymentMethodsId,
  postAdminV1StoresStoreIdPaymentMethods,
  type ManualPaymentMethod,
  type PatchAdminV1StoresStoreIdPaymentMethodsIdBody,
  type PostAdminV1StoresStoreIdPaymentMethodsBody,
} from '@nucleus-commerce/api-client/admin';

/** Manual payment methods of one store: a bounded `{ items }` list in display order. */
export const paymentMethodsApi = {
  list: (storeId: string): Promise<ManualPaymentMethod[]> =>
    getAdminV1StoresStoreIdPaymentMethods({ storeId }).then((r) => r.items),
  create: (
    storeId: string,
    body: PostAdminV1StoresStoreIdPaymentMethodsBody,
  ): Promise<ManualPaymentMethod> => postAdminV1StoresStoreIdPaymentMethods({ storeId }, body),
  update: (
    storeId: string,
    id: string,
    body: PatchAdminV1StoresStoreIdPaymentMethodsIdBody,
  ): Promise<ManualPaymentMethod> =>
    patchAdminV1StoresStoreIdPaymentMethodsId({ storeId, id }, body),
  remove: (storeId: string, id: string): Promise<void> =>
    deleteAdminV1StoresStoreIdPaymentMethodsId({ storeId, id }),
};
